export default __webpack_public_path__ + "static/media/flash15.bf51ae1f.png";